import {Notificator} from "./Notificator";

type CartPosition = {
    price: number|string,
    user_price: number|string,
    is_oversold: boolean,
    quantity: number|string,
    total: number|string
}
type CartServerResponse = {
    result: string,
    message?: string,
    coupon: string,
    positions: Record<number|string,CartPosition >,
    total: {
        has_oversold_positions: boolean,
        positions: number,
        cost: number|string,
        sell_cost: number|string,
        quantity: number|string
    }

}
document.addEventListener("DOMContentLoaded", () => {
    new Cart()
});

class Cart {
    addPath = '/cart/add'
    removePath = '/cart/delete'
    clearPath = '/cart/clear'
    updatePath = '/cart/update'

    private notificator: Notificator;
    private widgets: NodeListOf<Element>;
    private cart: Element | null = null;
    private emptyCart: Element | null = null;
    private cartCounter: Element | null = null;
    private cartTotalCost: Element | null = null;
    private cartClear: Element | null = null;

    constructor() {
        if (!window.notificator) {
            window.notificator = new Notificator()
        }
        this.notificator =  window.notificator
        this.widgets = document.querySelectorAll('[data-cart-widget-counter]')
        this.initAddButtons()
        this.initCartPage()
    }

    initCartPage() {
        this.cart = document.querySelector('[data-cart]')
        if (!this.cart) {
            return
        }
        this.emptyCart = document.querySelector('[data-cart-empty]')
        this.cartCounter = this.cart.querySelector('[data-cart-total]')
        this.cartTotalCost = this.cart.querySelector('[data-cart-total-cost]')
        this.cartClear = this.cart.querySelector('[data-cart-clear]')
        if (this.cartClear) {
            this.cartClear.addEventListener('click', (e) => {
                e.preventDefault()
                this.clear()
            })
        }
        this.initCartItems()
    }
    initCartItems() {
        if (!this.cart) {
            return
        }
        const items = this.cart.querySelectorAll('[data-cart-item]')
        items.forEach((cartItem) => {
            this.initCartItem(cartItem)
        })
    }
    initCartItem(cartItem: Element) {
        const deleteBtn = cartItem.querySelector('[data-remove]') as HTMLElement;
        const input = cartItem.querySelector('input[data-action="cart-update"]') as HTMLInputElement;
        const buttons = cartItem.querySelectorAll('button[data-action="cart-update"]') as NodeListOf<HTMLElement>;

        // Удаление
        if (deleteBtn) {
            deleteBtn.addEventListener('click', (e) => {
                e.preventDefault();
                const id = deleteBtn.dataset.remove ?? '';
                if (id) {
                    this.deletePosition(id, () => {
                        cartItem.remove();
                    });
                }
            });
        }

        // Изменение через input
        if (input) {
            input.addEventListener('change', () => {
                const id = input.dataset.id;
                if (!id) return;

                let value = Number(input.value);

                if (!value || value < 1) {
                    value = 1;
                    input.value = '1';
                }

                this.update(id, value, 0);
            });
        }

        // Кнопки + / -
        buttons.forEach(btn => {
            btn.addEventListener('click', (e) => {
                e.preventDefault();

                const id = btn.dataset.id;
                const increment = Number(btn.dataset.increment);

                if (!id || !increment) return;

                const currentQty = Number(input?.value || 1);

                // Запрещаем уменьшать меньше 1
                if (currentQty <= 1 && increment < 0) {
                    return;
                }

                this.update(id, increment, 1, (data) => {
                    const newQty = data.positions?.[id]?.quantity;

                    if (newQty !== undefined && input) {
                        input.value = String(newQty);
                    }
                });
            });
        });
    }

    renderWidget(total: number|string) {
        this.widgets.forEach(item => {
            item.innerHTML = String(total)
        })
    }

    formatMoney(value: number|string, showEmptyDash = false) {
        const amount = Number(value) || 0;

        if (showEmptyDash && amount <= 0) {
            return '—';
        }

        return new Intl.NumberFormat('ru-RU', {
            maximumFractionDigits: 0,
        }).format(amount) + ' ₽';
    }

    renderCartTotals(data: CartServerResponse) {
        if (this.cartCounter) {
            this.cartCounter.innerHTML = String(data.total.positions);
        }

        if (this.cartTotalCost) {
            this.cartTotalCost.innerHTML = this.formatMoney(data.total.cost);
        }
    }

    renderCartItemPrice(id: string | number, data: CartServerResponse) {
        if (!this.cart) {
            return;
        }

        const position = data.positions?.[id];
        const price = this.cart.querySelector('[data-cart-item-price="' + id + '"]');

        if (position && price) {
            price.innerHTML = this.formatMoney(position.total, true);
        }
    }

    initAddButtons() {
        document.addEventListener("click", (e) => {
            const target = e.target as HTMLElement | null;
            if (!target) return;

            const el = target.closest("button.add-to-cart");
            if (!el) return;

            // Проверяем, что это именно HTMLButtonElement
            const btn = el instanceof HTMLButtonElement ? el : null;
            if (!btn) return;

            e.preventDefault();
            const id = btn.dataset.id || '';

            this.add(id, 1, "", () => {
                btn.remove();
                const btnReplacer = document.querySelector('a.already-in-cart[data-id="'+ id +'"]')
                if (btnReplacer) {
                    btnReplacer.classList.remove('hidden')
                }
            } );
        });
    }

    notify(text: string, status:string) {
        this.notificator.addNotification(text, status)
    }

    clear() {
        fetch(this.clearPath, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "X-Requested-With": "XMLHttpRequest",
                "X-CSRF-TOKEN": document
                    .querySelector('meta[name="csrf-token"]')
                    ?.getAttribute("content")||'',
            },
        })
            .then((res) => res.json())
            .then((data) => {
                if (data.result === "success") {
                    this.renderWidget(data.total.positions);

                    this.cart?.remove()
                    if (this.emptyCart) {
                        this.emptyCart.classList.remove('hidden')
                    }

                    this.notify('Товар удален', '');
                }
            })
            .catch((err) => {
                console.error("Cart add error", err);
            });
    }
    deletePosition(id: string, callback=() => {}) {
        fetch(this.removePath, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "X-Requested-With": "XMLHttpRequest",
                "X-CSRF-TOKEN": document
                    .querySelector('meta[name="csrf-token"]')
                    ?.getAttribute("content")||'',
            },
            body: JSON.stringify({
                id: id,
            }),
        })
            .then((res) => res.json())
            .then((data) => {
                if (data.result === "success") {
                    callback();
                    this.renderWidget(data.total.positions);
                    this.renderCartTotals(data);
                    if (this.cart) {
                        if (data.total.positions) {
                            if (this.cartCounter) {
                                this.cartCounter.innerHTML = data.total.positions
                            }
                        } else {
                            this.cart.remove()
                            if (this.emptyCart) {
                                this.emptyCart.classList.remove('hidden')
                            }
                        }
                    }

                    this.notify('Товар удален', '');
                }
            })
            .catch((err) => {
                console.error("Cart add error", err);
            });
    }
    update(
        id: string | number,
        quantity: number | string,
        append = 0,
        callback = (data: CartServerResponse ) => {}
    ) {
        fetch(this.updatePath, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "X-Requested-With": "XMLHttpRequest",
                "X-CSRF-TOKEN": document
                    .querySelector('meta[name="csrf-token"]')
                    ?.getAttribute("content") || '',
            },
            body: JSON.stringify({
                id: id,
                qty: quantity,
                append: append,
            }),
        })
            .then(res => res.json())
            .then((data: CartServerResponse)  => {
                if (data.result === 'success') {
                    callback(data);
                    this.renderWidget(data.total.positions);
                    this.renderCartItemPrice(id, data);
                    this.renderCartTotals(data);
                }
            })
            .catch(err => {
                console.error('Cart update error', err);
            });
    }
    add(id: string | number, quantity = 1, comment = "", callback = () => {
    }) {
        fetch(this.addPath, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "X-Requested-With": "XMLHttpRequest",
                "X-CSRF-TOKEN": document
                    .querySelector('meta[name="csrf-token"]')
                    ?.getAttribute("content")||'',
            },
            body: JSON.stringify({
                id: id,
                qty: quantity,
                comment: comment,
            }),
        })
            .then((res) => res.json())
            .then((data) => {
                if (data.result === "success") {
                    callback();
                    this.renderWidget(data.total.positions);
                    this.notify('Товар добавлен в корзину', 'success');
                }
            })
            .catch((err) => {
                console.error("Cart add error", err);
            });
    }
}